import { render, staticRenderFns } from "./TransformMappers.vue?vue&type=template&id=634f87a6&"
import script from "./TransformMappers.vue?vue&type=script&lang=js&"
export * from "./TransformMappers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports